import React from "react";
import { Modal } from "react-bootstrap";

interface StatusModalProps {
  onSuccess?: any;
  onClose: (success: any) => void;
  shouldShow: boolean;
  message: any;
  type: number;
  unique_id?: string;
}

export default function StatusModal({ onSuccess, onClose, shouldShow, message, type, unique_id }: StatusModalProps) {
  return (
    <React.Fragment>
      <Modal
        show={shouldShow}
        backdrop="static"
        keyboard={false}
        className="dark-modal"
        centered
        contentClassName="custom-modal"
      >
        <Modal.Body>
          <div className="modal-body">
            <h4 className="rider-name-content">{message}</h4>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {/* <div className="btn-wrap mb-3 ">
                <button type="button"
                    className="rkmd-btn btn-lg btn-orange ripple-effect w-100 mt-3"
                    onClick={onClose}>
                    Close
                </button>
            </div> */}
          <div className="btn-wrap mb-3">
            <button className="btn btn-primary theme-primary-btn w-100 mt-4" onClick={onClose}>
              {type == 2 ? "Stay" : "Close"}
            </button>
          </div>
          {type == 2 && (
            <div className="btn-wrap mb-3">
              <button className="btn btn-primary theme-primary-btn w-100 mt-4" onClick={onSuccess}>
                Leave
              </button>
            </div>
          )}
          {type == 3 && (
            <div className="btn-wrap mb-3">
              <button className="btn btn-primary theme-primary-btn w-100 mt-4" onClick={() => onSuccess(unique_id)}>
                Confirm
              </button>
            </div>
          )}
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}
